import { render } from "./paymentPage.vue?vue&type=template&id=32848546&scoped=true"
import script from "./paymentPage.vue?vue&type=script&lang=js"
export * from "./paymentPage.vue?vue&type=script&lang=js"

import "./paymentPage.vue?vue&type=style&index=0&id=32848546&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32848546"]])

export default __exports__